import React from 'react';
import { styled } from '@abyss/ui/tools/styled';
import { Button } from 'src/common/Button';
import { useUserInfoStore } from 'src/store/useUserInfoStore';
import { useAdminContext } from 'src/hooks/useAdminContext';
import { redirectHandler } from 'src/tools/redirectHandler';

const ContinueButton = styled.div({
  margin: '20px 100px 20px 0',
  float: 'right',
});

export const PaperlessDeliveryUser = () => {
  const [, setAdminContext] = useAdminContext({
    onCompleted: () => {
      redirectHandler();
    },
  });
  const { data: userInfo } = useUserInfoStore();

  const handleContinue = () => {
    setAdminContext({
      variables: {
        role: 'pdo-admin-user',
        id: userInfo?.uuid || '',
        username: userInfo?.username || '',
      },
    });
  };

  return (
    <React.Fragment>
      <p data-testid="paperless-delivery-user-header">
        The ID you signed in with has Paperless Delivery User Access. If you do
        not need to emulate, click Continue.
      </p>
      <ContinueButton>
        <Button
          data-testid="continue-button"
          size="size700"
          onClick={handleContinue}
        >
          Continue
        </Button>
      </ContinueButton>
    </React.Fragment>
  );
};
